import React, { useState, useEffect } from 'react';
import { Box, IconButton, Input, Sheet, Typography } from '@mui/joy';
import { convertJSONKeyToTitle } from '../../helpers/KeyConverters';
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';
import { isIsoDate } from '../../helpers/TimeConversionHelper';


export default function HeadersTable({ label, defaultValue, headers, orientation, disabled, name, required }) {
    const createEmptyRow = () => {
        return headers.reduce((acc, header) => {
            acc[header] = '';
            return acc;
        }, {});
    };

    const [rows, setRows] = useState([createEmptyRow()]);
    const [submitValue, setSubmitValue] = useState(defaultValue);

    // Check if a row is completely filled
    const isRowComplete = (row) => {
        return headers.every(col => {
            return row[col] && row[col].trim() !== '';
        });
    };

    // Check if at least one row is complete
    const hasCompleteRow = () => {
        return rows.every(row => isRowComplete(row));
    };

    useEffect(() => {
        if (defaultValue && !Array.isArray(defaultValue) && typeof defaultValue === 'object' && Object.keys(defaultValue).length > 0) {
            setRows([defaultValue]);
        }
        else if (defaultValue && Array.isArray(defaultValue) && defaultValue.length > 0) {
            console.log("In here?");
            setRows(defaultValue);
        } 
        else if (defaultValue && typeof defaultValue === 'string') {
            const newRows = JSON.parse(defaultValue);
            if (typeof newRows === "string") {
                setRows([createEmptyRow()]);
            } else if (Array.isArray(newRows)) {
                setRows(newRows);
            } else if (typeof newRows === 'object') {
                setRows([newRows])
            } else {
                setRows(newRows)
            }
        } else {
            setRows([createEmptyRow()]);
        }
    }, []);

    const handleInputChange = (rowIndex, header, inputValue) => {
        const newRows = rows.map((row, index) => {
            if (index === rowIndex) {
                return { ...row, [header]: inputValue };
            }
            return row;
        });
        setRows(newRows);
        updateParent(newRows);
    };

    const addRow = () => {
        const newRows = [...rows, createEmptyRow()];
        setRows(newRows);
        updateParent(newRows);
    };

    const removeRow = () => {
        if (rows.length > 1) {
            const newRows = rows.slice(0, -1);
            setRows(newRows);
            updateParent(newRows);
        }
    };

    const updateParent = (newRows) => {
        setSubmitValue(newRows);
    };

    return (
        <Box sx={{ width: '100%', overflowX: 'auto' }}>
            <Typography level="body-lg" sx={{ display: 'flex', justifyContent: 'center' }}>{label || 'Table'}</Typography>
            <Sheet variant="outlined">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            {headers.map((header, index) => (
                                <th key={index} style={{ 
                                    padding: '8px', 
                                    borderBottom: '1px solid #ccc', 
                                    borderRight: '1px solid #ccc', 
                                    textAlign: 'center'
                                }}>
                                    <Typography level="body-sm" fontSize='16px' color='#32383E'>
                                        {convertJSONKeyToTitle(header)}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {headers.map((header, colIndex) => {
                                    if (header.includes('time')) {
                                        if(isIsoDate(row[header])) {
                                            row[header] = row[header].split("T")[1].split(".")[0]
                                        }
                                    }
                                    return <td key={colIndex} style={{ 
                                        borderBottom: '1px solid #ccc', 
                                        borderRight: '1px solid #ccc'
                                    }}>
                                        <Input
                                            value={row[header] || ''}
                                            disabled={disabled}
                                            onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                            size="sm"
                                            variant="plain"
                                            sx={{
                                                border: 'none',
                                                boxShadow: 'none',
                                            }}
                                        />
                                    </td>
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Sheet>
            <Box justifyContent='center' gap={2} display={orientation ? "none": "flex"}>
                <IconButton onClick={addRow} variant="outlined" sx={{ mt: 2 }} disabled={disabled}>
                    <Add />
                </IconButton>
                <IconButton onClick={removeRow} variant="outlined" sx={{ mt: 2 }} disabled={rows.length === 1 || disabled}>
                    <Remove />
                </IconButton>
            </Box>
            <input 
                type="text" 
                name={name} 
                value={hasCompleteRow() ? (typeof submitValue === 'string' ? submitValue : JSON.stringify(submitValue)) : ""}
                required={required}
                style={{
                    position: "absolute",
                    left: "-9999px"
                }}
            />
        </Box>
    );
}